import React, { useState, useEffect } from 'react';
import { apiRequest } from "../services/api";

import { useParams, Link, useLocation } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import Modal from 'react-modal';
import EnquiryModal from '../components/EnquiryModal';

Modal.setAppElement('#root');

const visaData = [
    {
        id: 1,
        title: 'US Visa',
        slug: 'us-visa',
        img: '/img/us.jpg',
        description: "Planning a holiday or business trip to the USA? Apply from Dubai with ease...",
        documents: [
            "Passport: Original and copy, valid for at least 6 months.",
            "Emirates ID & Residence Visa",
            "No Objection Letter: From the company or sponsor of the applicant.",
            "Bank Statement: copy of the last 6 months' Statement Stamp from the Bank",
            "Return Ticket: Copy of your return flight ticket.",
            "Hotel Reservation: Copy of your hotel booking at your destination.",
            "Cover Letter detailing your travel plan",
            "Trade licenses copy If your company owners or partners"
        ]
    },
    {
        id: 2,
        title: 'UK Visa',
        slug: 'uk-visa',
        img: '/img/uk.jpeg',
        description: "Looking to apply for a UK visa from Dubai? Holiday Basket ensures a stress-free process.",
        documents: [
            "Passport",
            "Emirates ID",
            "NOC Letter",
            "Bank Statement",
            "Hotel and Flight Booking",
            "Cover Letter",
            "Trade License"
        ]
    },
    {
        id: 3,
        title: 'Canada Visa',
        slug: 'canada-visa',
        img: '/img/canada.jpg',
        description: "Need a Canada visa from Dubai? We guide you from start to finish.",
        documents: [
            "Passport",
            "Emirates ID",
            "NOC Letter",
            "6-month bank statement",
            "Travel bookings",
            "Invitation letter (if applicable)"
        ]
    },
    {
        id: 4,
        title: 'Japan Visa',
        slug: 'japan-visa',
        img: '/img/japan.jpg',
        description: "We offer seamless Japan visa support from Dubai.",
        documents: [
            "Passport copy",
            "Residence proof",
            "Letter of employment",
            "Financial proof",
            "Flight + hotel booking",
            "Visa form"
        ]
    }
];

const VisaDetails = () => {
    const { slug } = useParams();
    const { state: id } = useLocation();
    const [data, setData] = useState([]);

    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        if (id) {
            apiRequest({ url: `/visa/${id}` })
                .then((res) => {
                    if (res.success) {
                        setData(res.data);
                    } else {
                        console.warn("Unexpected response format:", res);
                    }
                })
                .catch((err) => {
                    console.error("Error loading hero slides:", err.message);
                });
        }
    }, [id]);

    if (!data) {
        return <div className="container py-5"><h3>Visa details not found.</h3></div>;
    }

    return (

        <>
            <PageHeader
                title="Visa"
                image="../img/world.png" // Use your own path
                breadcrumbs={[
                    { label: "Visa", active: false, path: '/visas' },
                    { label: data.title, active: true },

                ]}
            />

            <section className="py-5">
                <div className="container">
                    <div className='row'>
                        <div className='col-12 col-lg-4 bg-cover bg-center pt-3'>
                            <img src={data.img} alt={data.title} className="img-fluid rounded w-100" />
                        </div>
                        <div className='col-12 col-lg-8 pt-3'>
                            <h3 className="mb-3">{data.title}</h3>
                            {/* <p>{data.description}</p> */}

                            {/* <h5 className="mt-4">Required Documents:</h5> */}
                            {/* <ul style={{ paddingLeft: '1rem' }}>
                                {data.documents.map((doc, i) => (
                                    <li key={i}>{doc}</li>
                                ))}
                            </ul> */}
                            <div
                                className="visa-description"
                                dangerouslySetInnerHTML={{ __html: data.description }}
                            />

                            <div className="mt-2">
                                <a className="btn-hover-bg btn btn-sm btn-primary rounded-pill text-white py-2 px-3 px-md-5" onClick={() => setModalOpen(true)}>Enquiry Now</a>
                                <Link
                                    className="btn-hover-bg btn ms-2 btn-sm btn-primary rounded-pill text-white py-2 px-3 px-md-5"
                                    to="/visas"
                                >
                                    Back to Visa
                                </Link>

                                <EnquiryModal isOpen={modalOpen} onRequestClose={() => setModalOpen(false)} />
                            </div>
                        </div>
                    </div>

                </div>
            </section>



        </>
    );
};

export default VisaDetails;
